import axios from 'axios';

const baseUrl = 'https://custom-forms-client.acerill.com/data';

const getCountries = () => {
  return axios.get(baseUrl + '/countries.json')
    .then(response => response.data);
};

const getUsStates = () => {
  return axios.get(baseUrl + '/us-states.json')
    .then(response => response.data);
};

const customFormsClientDataClient = {
  getCountries,
  getUsStates,
};
export default customFormsClientDataClient;